module.exports = __webpack_public_path__ + "09ee1d667a58900d6d7f2d99bc354755.svg";